export function isLogin() {
    return localStorage.token ? true : false;
}

export function crearUsuario(usuario) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
            body: JSON.stringify(usuario),
        };

        fetch(`${process.env.REACT_APP_API_URL}/registrar`, requestOptions).then(
            (response) => {
                response.json().then((data) => {
                    if (response.status === 201 && data.affectedRows === 1) {
                        resolve();
                    } else {
                        reject();
                    }
                });
                console.log(response);
            }
        );
    });
}

export function getStatusStudentList() {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URL}/statusStudent`)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getSupervisor() {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URL}/supervisor`)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getEspecialidades(id = null) {
    return new Promise((resolve, reject) => {
        let url = new URL(`${process.env.REACT_APP_API_URL}/especialidades`);
        let params = { id: id };
        url.search = new URLSearchParams(params).toString();
        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(reject);
    });
}

export function getEstudiantes() {

    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        fetch(`${process.env.REACT_APP_API_URL}/interesados`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getClientById(id = null) {
    return new Promise((resolve, reject) => {
        let url = new URL(`${process.env.REACT_APP_API_URL}/estudiante`);
        let params = { id: id };
        url.search = new URLSearchParams(params).toString();
        fetch(url)
            .then((res) => res.json())
            .then((client) => {
                resolve(client);
            })
            .catch(console.log);
    });
}

export function getAgencias() {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        fetch(`${process.env.REACT_APP_API_URL}/agencias`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getEstudiantePorTelefono(telefono) {
    return new Promise((resolve, reject) => {
        let url = new URL(`${process.env.REACT_APP_API_URL}/estudiante`);
        let params = { telefono: telefono };
        url.search = new URLSearchParams(params).toString();
        fetch(url)
            .then((res) => res.json())
            .then((estudiante) => {
                resolve(estudiante);
            })
            .catch(console.log);
    });
}

export function getUsuarios() {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        fetch(`${process.env.REACT_APP_API_URL}/usuarios`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getPerfiles() {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        fetch(`${process.env.REACT_APP_API_URL}/perfiles`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getPermissions() {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        fetch(`${process.env.REACT_APP_API_URL}/permissions`, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function filterStudents(filters) {

    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
        };
        let url = new URL(`${process.env.REACT_APP_API_URL}/interesados`);
        url.search = new URLSearchParams(filters).toString();
        fetch(url, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function getSpecialties(filters) {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URL}/especialidades`)
            .then((response) => response.json())
            .then((specialties) => {
                resolve(specialties);
            });
    });
}

export function payCommission(commission) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.token,
            },
            body: JSON.stringify(commission),
        };

        fetch(`${process.env.REACT_APP_API_URL}/commission`, requestOptions).then(
            (response) => {
                response.json().then((data) => {
                    if (response.status === 201 && data.affectedRows === 1) {
                        resolve();
                    } else {
                        reject();
                    }
                });
                console.log(response);
            }
        );
    });
}

export function getInterest(id) {
    return new Promise((resolve, reject) => {
        let url = new URL(`${process.env.REACT_APP_API_URL}/intereses`);
        let params = { id: id };
        url.search = new URLSearchParams(params).toString();
        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(console.log);
    });
}

export function changeStatusEspecialidad(especialidad) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(especialidad),
        };

        fetch(`${process.env.REACT_APP_API_URL}/especialidad`, requestOptions).then(
            (response) => {
                if (response.status === 204) {
                    resolve();
                } else {
                    reject();
                }
                console.log(response);
            }
        );
    });
}

export function changeStatusAgencia(agencia) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(agencia),
        };

        fetch(`${process.env.REACT_APP_API_URL}/agencia`, requestOptions).then(
            (response) => {
                if (response.status === 204) {
                    resolve();
                } else {
                    reject();
                }
                console.log(response);
            }
        );
    });
}

export function changeStatusEstudiante(estudiante) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(estudiante),
        };

        fetch(`${process.env.REACT_APP_API_URL}/estudiante`, requestOptions).then(
            (response) => {
                if (response.status === 204) {
                    resolve();
                } else {
                    reject();
                }
                console.log(response);
            }
        );
    });
}

export function insertEspecialidad(especialidad) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(especialidad),
        };

        fetch(`${process.env.REACT_APP_API_URL}/especialidad`, requestOptions).then(
            (response) => {
                response.json().then((data) => {
                    if (response.status === 201 && data.affectedRows === 1) {
                        alert("Se creo correctamente.");
                        resolve();
                    } else {
                        alert("No se pudo crear.");
                        reject();
                    }
                });
                console.log(response);
            }
        );
    });
}

export function insertAgencia(agencia) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(agencia),
        };

        fetch(`${process.env.REACT_APP_API_URL}/agencia`, requestOptions).then(
            (response) => {
                response.json().then((data) => {
                    if (response.status === 201 && data.affectedRows === 1) {
                        alert("Se creo correctamente.");
                        resolve();
                    } else {
                        alert("No se pudo crear.");
                        reject();
                    }
                });
                console.log(response);
            }
        );
    });
}

export function allowOnlyNumbers(e) {
    return (e.target.value = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1"));
}

export function formatPhoneNumber(e) {
    var x = e.target.value
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return (e.target.value = !x[2]
        ? x[1]
        : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : ""));
}
